import Button from "./button/Button";
import PasswordInput from "./passwordInput/PasswordInput";

import * as regex from '../../service/regex';

export default function ChangePasswordComponent({currentPass, setCurrentPass, newPass, setNewPass, confirmPassword, setConfirmPassword, onClickSubmit}) {
    return (
        <div className='flex justify-center w-full'>
            <div className='flex flex-col gap-4 w-[600px] justify-center'>
            
                    {/* <PasswordInput label="ระบุรหัสปัจจุบัน" id="current-password" placeholder="ระบุรหัสปัจจุบัน" value={currentPass} setValue={setCurrentPass} /> */}
                    <PasswordInput label="ระบุรหัสผ่านใหม่" id="new-password" regex={regex.password()} placeholder="ระบุรหัสผ่านใหม่" value={newPass} setValue={setNewPass} />
                    <PasswordInput label="ยืนยันรหัสผ่านใหม่อีกครั้ง" id="confirm-password" regex={regex.password()} placeholder="ยืนยันรหัสผ่านใหม่อีกครั้ง" value={confirmPassword} setValue={setConfirmPassword} />
                    <Button onClick={onClickSubmit}>บันทึกการเปลี่ยนแปลง</Button>
                </div>
            </div>
        
    )
}